



























import { Component, Vue } from 'vue-property-decorator';
import UserMenu from './UserMenu.vue';

@Component({
  components: {
    UserMenu
  }
})
export default class HeaderNavbar extends Vue {}
